import React from 'react';
import Panel from 'muicss/lib/react/panel';
import Button from 'muicss/lib/react/button';
import Input from 'muicss/lib/react/input';

class ReceivingTestSetup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {scenario: 'receive'};
  }

  onChangeValue(name, ev) {
    let state = {};
    state[name] = ev.target.value;
    this.setState(state);
  }

  onSubmit() {
    this.props.onStartTest(this.state);
  }

  render() {
    let testInfo = <p className="mui--text-body2">
      <span>This test will attempt to send a payment to your account using compliance protocol.</span>
    </p>

    return <div>
      <div className={this.props.id ? 'hide' : ''}>
        {testInfo}
        <Input label="Enter your recipient address" floatingLabel={true} onChange={this.onChangeValue.bind(this, "address")} />
        <Input label="Enter amount to send" floatingLabel={true} onChange={this.onChangeValue.bind(this, "amount")} />
        <Input label="Asset code" floatingLabel={true} onChange={this.onChangeValue.bind(this, "asset_code")} />
        <Input label="Asset issuer" floatingLabel={true} onChange={this.onChangeValue.bind(this, "asset_issuer")} />
        <p><small>
          All tests are performed in the test network.
          You must follow <a href="https://www.stellar.org/developers/guides/compliance-protocol.html" target="_blank">Compliance protocol</a> in order to pass tests.
          Using <a href="https://github.com/stellar/bridge-server" target="_blank">Bridge</a> server can be very helpful.
        </small></p>
        <Button
          color="primary"
          disabled={this.props.initializing}
          onClick={this.onSubmit.bind(this)}>Start test</Button>
      </div>
      <div className={!this.props.id ? 'hide' : ''}>
        <p>Selected test:</p>
        {testInfo}
        <button
          className="mui-btn mui-btn--flat mui-btn--danger"
          onClick={this.props.onCancelTest}>Cancel test</button>
      </div>
    </div>
  }
}

ReceivingTestSetup.propTypes = {
  onStartTest: React.PropTypes.func,
  onCancelTest: React.PropTypes.func,
};

export default ReceivingTestSetup;



// WEBPACK FOOTER //
// ./src/components/ReceivingTestSetup.js